import { h, Fragment, FunctionComponent } from 'preact';
import classnames from 'classnames';

type Props = {
    rating: number;
    starCount?: number;
};

export const StarRating: FunctionComponent<Props> = ({ rating, starCount = 5 }) => (
    <Fragment>
        {[...Array(starCount)].map((_, i) => (
            <div
                key={i}
                className={classnames('c-star-rating', {
                    'is-full': i + 1 <= Math.floor(rating),
                    'is-decimal': i + 1 === Math.ceil(rating),
                })}
                style={
                    i + 1 === Math.ceil(rating)
                        ? {
                              '--decimal': parseInt(((rating % 1) * 100).toFixed(0), 10),
                          }
                        : undefined
                }
            />
        ))}
    </Fragment>
);
